module.exports = __webpack_public_path__ + "a3766925def229003c69149e8ccc248d.png";